<template>
  <v-card elevation="3" class="rounded-xl">
    <v-row no-gutters>
      <v-col
        cols="12" md="1" lg="1" xl="1"
        class="d-flex justify-center align-start"
      >
          <v-avatar
            size="56"
            rounded
            class="mt-6"
            v-if="scheduleData.type == 'student'"
          >
            <img
              v-if="deptLogos[scheduleData.dept] !== null"
              :src="deptLogos[scheduleData.dept]"
              alt="img"
            />
            <v-icon v-else>
              mdi-account-group
            </v-icon>
          </v-avatar>

          <v-avatar
              size="56"
              color="info"
              class="mt-6"
              v-else-if="scheduleData.type == 'prepod'"
          >
            <v-icon dark>mdi-account</v-icon>
          </v-avatar>

          <v-avatar
              size="56"
              color="blue"
              class="mt-6"
              v-else-if="scheduleData.type == 'cat'"
          >
            <v-tooltip
                v-model="catHappy"
                left
                close-delay="1"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon dark large v-bind="attrs" v-on="on">mdi-cat</v-icon>
              </template>
              <span>meow meow</span>
            </v-tooltip>
          </v-avatar>
          <div v-else></div>
      </v-col>

      <v-col cols="12" md="11" lg="11" xl="11">
        <v-card-title
            class="justify-center justify-md-start justify-lg-start justify-xl-start text-center text-md-start text-lg-start text-xl-start"
            style="word-break: normal"
        >
          {{scheduleData.name}}
        </v-card-title>
        <v-card-text class="text--secondary">
          <div v-if="scheduleData.type == 'student'" class="justify-center justify-md-start justify-lg-start justify-xl-start text-center text-md-start text-lg-start text-xl-start">
            {{scheduleData.dept_name}} <br />
            {{scheduleData.course}}, {{scheduleData.study_type}} <br />
            {{scheduleData.study_time}}
          </div>
          <div v-else-if="scheduleData.type == 'prepod' && scheduleData.groups != null">

            <div class="mb-1 justify-center justify-md-start justify-lg-start justify-xl-start text-center text-md-start text-lg-start text-xl-start">
              Ведет у групп:
            </div>

            <v-chip
                v-for="(hours, group) in scheduleData.groups" :key="group"
                color="info" outlined link
                class="ma-1 ml-0 mr-2"
                :to="group"
            >
              {{group}}
            </v-chip>

          </div>
          <div v-else-if="scheduleData.type == 'cat'" class="justify-center justify-md-start justify-lg-start justify-xl-start text-center text-md-start text-lg-start text-xl-start">
            {{scheduleData.dept_name}} <br />
            Ведет у всех групп
          </div>
          <div v-else></div>

          <!--<ScheduleAlert v-if="scheduleData.type != 'cat'" class="mt-4" />-->

        </v-card-text>
      </v-col>
    </v-row>
    <v-card-actions>
      <v-btn
          v-if="scheduleData.type == 'cat'"
          block
          color="primary"
          text
          rounded
          @click="catHappy = !catHappy"
      >
        <v-icon class="mr-2" small>mdi-hand-wave-outline</v-icon>
        погладить
      </v-btn>

      <div v-else class="d-flex" style="width: 100%">
        <div style="width: 100%">
          <v-btn
              block
            color="primary"
            text
            rounded
            :href="scheduleDownloadLink"
            @click="metrikaScheduleClick"
            download
          >
            <v-icon class="mr-1">mdi-download</v-icon>
            загрузить
          </v-btn>
        </div>
        <v-divider class="mr-1"/>
        <div>
          <v-btn
            color="primary"
            text
            rounded
            icon
            @click="copyURL"
            download
          >
            <v-icon>mdi-link-variant</v-icon>
          </v-btn>

          <v-snackbar
              v-model="linkSnackbar"
              timeout="1000"
              text color="primary" rounded="pill"
              class="mb-12"
          >
            Ссылка скопирована
            <!--<template v-slot:action="{ attrs }">
              <v-btn
                  color="pink"
                  text
                  v-bind="attrs"
                  @click="snackbar = false"
              >
                Close
              </v-btn>
            </template>-->
          </v-snackbar>
        </div>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
//import ScheduleAlert from "@/components/ScheduleAlert";

export default {
  name: "ScheduleDownload",
  props: {
    scheduleData: Object
  },
  components: {
    //ScheduleAlert: ScheduleAlert
  },
  data() {
    return {
      deptLogos: {
        1: require('../assets/faculty_logos/1.gif'),
        2: require('../assets/faculty_logos/2.gif'),
        3: require('../assets/faculty_logos/3.gif'),
        4: require('../assets/faculty_logos/4.gif'),
        5: require('../assets/faculty_logos/5.jpg'),
        6: require('../assets/faculty_logos/6.png'),
        7: require('../assets/faculty_logos/7.png'),
        8: require('../assets/faculty_logos/8.gif'),
        9: require('../assets/faculty_logos/9.gif'),
        10: require('../assets/faculty_logos/10.png'),
        11: require('../assets/faculty_logos/11.jpg'),
        12: require('../assets/faculty_logos/12.png'),
        14: require('../assets/faculty_logos/14.png')
      },
      catHappy: false,
      linkSnackbar: false
    }
  },
  computed: {
    scheduleDownloadLink: function () {
      return '/icals/' + this.scheduleData.filename + '.ics'
    }
  },
  methods: {
    metrikaScheduleClick() {
      return
      // this.$metrika.hit(this.scheduleData.name)
    },
    copyURL() {
      navigator.clipboard
          .writeText(window.location)
          .then(() => {
            this.linkSnackbar = true
          })
          .catch((err) => {
            console.log(err)
          })
    }
  }
}
</script>
